import { SET_ACTIVE_TOP_LABEL } from "core-web/state/models/Header/constants";
import store from "core-web/state/store";

export const setActiveTopLabel = (activeNavTopLabel) => (dispatch) => {
    dispatch({
        type: SET_ACTIVE_TOP_LABEL,
        activeNavTopLabel,
    });
};

export default (activeNavTopLabel) => store.dispatch(setActiveTopLabel(activeNavTopLabel));
